import { Box, Dialog } from '@monorepo/nova-ui';
import { alpha, styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: theme.spacing(10),
    border: '2px solid transparent',
    background: `linear-gradient(${theme.palette.background.default}, ${theme.palette.background.default}) padding-box, linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main}) border-box`,
    boxShadow: `0 144px 250px 0 ${alpha(theme.palette.secondary.main, 0.2)}`,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: theme.spacing(146),
    maxWidth: theme.spacing(223.5),
    boxSizing: 'content-box',
    margin: 0,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      width: theme.spacing(84),
      height: 'auto',
      maxHeight: '90vh',
      maxWidth: '100%',
      position: 'relative',
    },
  },
}));

export const StyledDialogPaperInner = styled(Box)(({ theme }) => ({
  position: 'relative',
  flex: '1 1 0',
  minWidth: 0,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  paddingInline: theme.spacing(12),
  paddingTop: theme.spacing(12),
  paddingBottom: theme.spacing(12),
  [theme.breakpoints.down('md')]: {
    flex: '1 1 100%',
    minHeight: 0,
    paddingInline: theme.spacing(6),
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  },
}));

/** Flex container for slide content: fills height and pushes buttons to bottom via justifyContent: space-between (used in both desktop and mobile modals) */
export const StyledSlideContentFlex = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  flex: 1,
  minHeight: 0,
}));
